import React from 'react';
import { format } from 'date-fns';
import '../../less/bootstrap.less';
import '../../assets/css/fontawe.css';
import './HeaderInvoice.css';
import { dollarNumber, centNumber } from '../../utils/Currency';
import { getPaymentStatus } from '../../utils/invoice';
import _ from 'lodash';
import { isAndroid } from 'react-device-detect';
import { ecalAlert } from './EcalAlert';

export type HeaderInvoiceProps = {
    readonly loading: boolean
    readonly error: boolean
    readonly invoice: any
    readonly takingPayment?: boolean
    readonly recording?: boolean
    readonly inPayment?: boolean
    readonly showInTrayButtons?: boolean
    readonly supplierFeedExists?: boolean
    readonly hideAdminButtons?: boolean
    readonly isShowEcalAlert?: boolean
    readonly print?: () => void
    readonly linkToMYOB?: () => void
    readonly removeLinkFromMYOB?: () => void
    readonly activity?: () => void
}

export const HeaderInvoiceError = () => {
    return (
        <div className='container text-center'>
            <div className='row'>
                <div className='col-xs-12 col-sm-12 col-md-12'>
                    <div className='errorBody'>
                        <b className='errorBodyHeader'>:(</b>
                        <h2>Well,
                            this is awkward. Looks like something went wrong!<br />
                            Please try again later or contact the issuing business for assistance.</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const HeaderInvoiceLoading = () => {
    return (
        <div className='loading_invoice'>
            <div className='flx-loading-spinner-lg' />
        </div>
    );
};

export class HeaderFooterInvoice extends React.Component<HeaderInvoiceProps> {
    render() {
        if (this.props.loading) {
            return <div />;
        }
        if (this.props.error) {
            return <div />;

        }
        if (!this.props.takingPayment && !this.props.recording) {
            return (
                <div id='stickySource'>
                    {this.renderMobileHeaderTop()}
                </div>
            );
        }
    }

    renderMobileHeaderTop() {
        const publicUrl = process.env.REACT_APP_REDIRECT_URL ? process.env.REACT_APP_REDIRECT_URL : '';
        const hrefLink = publicUrl + '/privacy';
        return (
            <>
                <div id='footer-placeholder'></div>
                <header id='mobile-header' className='hidden-lg hidden-sm hidden-md'>
                    <div>
                        <div className='myob'>
                            <span className='power-by'>Powered by</span>
                            <img src={require('../../assets/img/logo-gradient.png')} width='60px' />
                        </div>
                        <div className='privacy'>
                            <a href={hrefLink}>Privacy</a>
                        </div>
                    </div>
                </header>
            </>
        );
    }

}

export class HeaderInvoice extends React.Component<HeaderInvoiceProps> {
    render() {
        const ieVersion9 = !!document['documentMode'] && document['documentMode'] === 9;
        if (this.props.loading) {
            return <HeaderInvoiceLoading />;
        }
        if (this.props.error) {
            return <HeaderInvoiceError />;
        }
        if (!this.props.takingPayment && !this.props.recording) {
            return (
                <div id='stickySource'>
                    {this.renderHeaderTop(ieVersion9)}
                    {this.renderInvoiceHeader()}
                </div>
            );
        }
    }

    renderHeaderTop(ieVersion9) {
        return (
            <header id='header' className='hidden-xs'>
                <div className='navbar-myob-header'>
                    <div className='container'>
                        <div className='navbar-brand'>
                            <div id='MYOBLogo-desc' className='svg-logo'>
                                {ieVersion9 && <img src={require('../../assets/img/logo-gradient.png').default} />}
                                <div className='IE10logo'>
                                    <img src={require('../../assets/img/logo-gradient.png').default} />
                                </div>
                                <img src={require('../../assets/img/logo.svg').default} />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    renderInvoiceHeader() {
        const invoice = this.props.invoice;
        const paymentStatus = getPaymentStatus(invoice);
        const dueAmount = invoice.meta.is_foreign ? invoice.meta.due_amount_foreign : invoice.meta.due_amount;
        const totalAmount = invoice.meta.is_foreign ? invoice.meta.total_amount_foreign : invoice.meta.total_amount;

        return (
            <div className={'invoice_header' + (this.props.inPayment ? ' payment-header' : '')}>
                <div className='container'>
                    <div className='row'>
                        <div className='header_info clearfix'>
                            <div className='row'>
                                <div className='icon_col'>
                            <span className='stack'>
                                <i className='icon-invoice stack-large'></i>
                            </span>
                                </div>
                                {this.renderInvoiceHeaderLeft(paymentStatus)}
                            </div>
                            {this.renderHeaderInvoiceButton()}
                        </div>
                        {this.renderInvoiceHeaderRight(paymentStatus, totalAmount, dueAmount)}
                    </div>
                </div>
            </div>
        );
    }

    renderHeaderInvoiceButton() {
        const { hideAdminButtons, invoice, supplierFeedExists, showInTrayButtons } = this.props;
        if (hideAdminButtons) {
            return null;
        }

        return (
            <div className='admin-buttons'>
                {invoice.pdf_available == true && !invoice.meta.status_is_overridden &&
                    <div className='invoice_toolbar btn-group hidden-xs'>
                        {isAndroid && <a id='download-invoice-control' className='btn btn-default btn-lg'
                                         style={{ textDecoration: 'none' }}
                                         href={invoice.download_pdf_url}><i
                            className='icon-archive'></i><span
                            className='button-label'>&nbsp;PDF</span></a>
                        }
                        {!isAndroid && <a id='download-invoice-control'
                                          style={{ textDecoration: 'none' }}
                                          className='btn btn-default btn-lg'
                                          href={invoice.download_pdf_url} download>
                            <i className='icon-archive'></i>
                            <span className='button-label'>&nbsp;PDF</span></a>
                        }
                        <a id='print-invoice-control' className='btn btn-default btn-lg'
                           style={{ textDecoration: 'none' }}
                           onClick={this.props.print}><i className='icon-printEd'></i><span
                            className='button-label'>&nbsp;Print</span></a>
                        {!supplierFeedExists && showInTrayButtons && !invoice.fromSmepApi &&
                            <a id='send-to-intray-control'
                               className='btn btn-default btn-lg'
                               style={{ textDecoration: 'none' }}
                               onClick={this.props.linkToMYOB}><i
                                className='icon-linked2'></i><span
                                className='button-label'>&nbsp;Link to MYOB</span></a>
                        }
                        {supplierFeedExists && showInTrayButtons &&
                            <a id='unlink-from-intray-control' className='btn btn-default btn-lg'
                               style={{ textDecoration: 'none' }}
                               onClick={this.props.removeLinkFromMYOB}><i
                                className='icon-unlink'></i><span className='button-label'>&nbsp;Unlink from MYOB</span></a>
                        }
                        {!invoice.fromSmepApi &&
                            <a id='invoice-activity-control' className='btn btn-default btn-lg a'
                               style={{ textDecoration: 'none' }}
                               onClick={this.props.activity}>
                                <i className='icon-history'></i><span className='button-label'>&nbsp;Activity</span></a>
                            // <a id='invoice-activity-control' className='btn btn-default btn-lg'
                            //    onClick={this.props.activity}><i
                            //     className='icon-history'></i><span className='button-label'>&nbsp;Activity</span></a>
                        }
                    </div>}
                {invoice.pdf_available == true && !invoice.meta.status_is_overridden &&
                    <div className='invoice_toolbar btn-group visible-xs'>
                        {isAndroid && <a id='download-mobile-invoice-control'
                                         className='btn btn-default btn-lg' href={invoice.download_pdf_url}><i
                            className='icon-archive'></i><span className='button-label'>&nbsp;&nbsp;Download PDF</span></a>
                        }
                        {!isAndroid && <a id='download-mobile-invoice-control'
                                          className='btn btn-default btn-lg' href={invoice.download_pdf_url} download><i
                            className='icon-archive'></i><span
                            className='button-label'>&nbsp;&nbsp;Download PDF</span></a>
                        }
                    </div>}
                {invoice.pdf_available == true && !invoice.meta.status_is_overridden &&
                    <div className='invoice_toolbar btn-group visible-xs'>
                        <a id='invoice-mobile-activity-control' className='btn btn-default btn-lg'
                           onClick={this.props.activity}><i className='icon-history'></i><span
                            className='button-label'>&nbsp;&nbsp;Invoice
                                    activity</span></a>
                    </div>
                }
                {invoice.pdf_available == true && !invoice.meta.status_is_overridden &&
                    <div className='invoice_toolbar btn-group visible-xs'>
                        {!supplierFeedExists && showInTrayButtons &&
                            <a id='send-to-intray-control' className='btn btn-default btn-lg'
                               onClick={this.props.linkToMYOB}><i className='icon-linked2'></i><span
                                className='button-label'>&nbsp;&nbsp;Linkto MYOB</span></a>
                        }
                        {supplierFeedExists && showInTrayButtons &&
                            <a id='unlink-from-intray-control' className='btn btn-default btn-lg'
                               onClick={this.props.removeLinkFromMYOB}><i className='icon-unlink'></i><span
                                className='button-label'>&nbsp;&nbsp;Unlink from MYOB</span></a>
                        }
                    </div>
                }
            </div>
        );
    }

    renderInvoiceHeaderLeft(paymentStatus) {
        return (
            <div className='info_col'>
                <h1>
                    <span className='InvoiceHeaderLeftTop'>{this.props.invoice.company.name}</span>
                </h1>
                {
                    _.get(this.props, 'isShowEcalAlert', false) && <div className='visible-xs' id='ecalContainer'>
                        {ecalAlert(_.get(this.props, 'isShowEcalAlert', false))}
                    </div>
                }
                <h5>
                    <span className='date_due_head'><i className='icon-invoice'></i>
                        Invoice no: <em>{this.props.invoice.meta.number}</em></span>
                    <span className='info_from date_due_head visible-xs'><i className='icon-userProfile'></i>
                                    To: <em>{this.props.invoice.customer.name}</em></span>
                    <span className='info_spacer'>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                    {!_.isEqual(paymentStatus, 'paid') &&
                        <span className={'date_due_head date_paid'}><i
                            className='icon-calendar'></i> Due date: <em>{
                            format(new Date(this.props.invoice.meta.due_date), 'dd/MM/yyyy')}</em></span>
                    }
                    {_.isEqual(paymentStatus, 'paid') && this.props.invoice.meta.last_payment_date &&
                        <span className='date_due_head date_paid'><i
                            className='icon-calendar'></i> Date paid: <em>{
                            format(new Date(this.props.invoice.meta.last_payment_date), 'dd/MM/yyyy')}</em></span>
                    }
                </h5>
            </div>
        );
    }

    renderInvoiceHeaderRight(paymentStatus, totalAmount, dueAmount) {
        return (
            <div className='header_value clearfix'>

                <ul>
                    {_.isEqual(paymentStatus, 'paid') && <li className='invoice_amount'>
                        {!this.props.invoice.meta.is_foreign && <sup
                            className='dollar'>$</sup>}{dollarNumber(totalAmount)}<sup>{centNumber(totalAmount)}<sub>{
                        this.props.invoice.meta.currency}</sub></sup></li>}
                    {!_.isEqual(paymentStatus, 'paid') && <li className='invoice_amount'>
                        {!this.props.invoice.meta.is_foreign &&
                            <sup className='dollar'>$</sup>}{dollarNumber(dueAmount)}<sup>{centNumber(dueAmount)}<sub>{
                        this.props.invoice.meta.currency}</sub></sup></li>
                    }
                    {_.isEqual(paymentStatus, 'paid') &&
                        <li className={'invoice_status_icon' + (paymentStatus == 'due' || paymentStatus == 'paid' ? 'green' : 'overdue')}></li>
                    }
                    {_.isEqual(paymentStatus, 'due') &&
                        <li className='invoice_status'>NOW DUE
                        </li>
                    }
                    {_.isEqual(paymentStatus, 'overdue') &&
                        <li className='invoice_status overdue'>OVERDUE</li>
                    }
                    {_.isEqual(paymentStatus, 'paid') &&
                        <li className='invoice_status paid'>PAID</li>
                    }
                </ul>
            </div>
        );
    }

}

export default HeaderInvoice;

